import { render, staticRenderFns } from "./aside.vue?vue&type=template&id=1d9ff095&scoped=true"
import script from "./aside.vue?vue&type=script&lang=ts"
export * from "./aside.vue?vue&type=script&lang=ts"
import style0 from "./aside.vue?vue&type=style&index=0&id=1d9ff095&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9ff095",
  null
  
)

export default component.exports